<template>
  <div>
    <div class="box">

      <div v-if="gameType === GameType.TOURNAMENT" class="round-robin" :key="componentKey+(match.uniqueId)">
        <div class="columns is-mobile">
          <div class="column is-5" :key="matchComponentKey+(match.uniqueId)">
            <div v-for="matchPlayer in match.matchPlayers" :key="matchPlayer.matchPlayer">
                <MatchPlayer :matchPlayer="matchPlayer" :gameType="gameType"/>
            </div>
          </div>
          <div class="column is-7 target-box">
            <div class="columns is-mobile">
              <div class="column is-1" style="vertical-align: top;">
                <span class="is-size-3 is-light last-throw">{{lastThrowPoints}}</span>
              </div>
              <div class="column is-11">
                <div class="target-hit-overlay">
                  <img class="axes2-target" :src="`${publicPath}img/Target_400x377.PNG`" :usemap="'#'+mapUniqueId" width="400" height="377">
                  <map :name="mapUniqueId">
                    <area alt="5" title="5" points="5" v-on:click="axeHit" onclick="return false;" href="#" coords="200,189,29" shape="circle">
                    <area alt="4" title="4" points="4" v-on:click="axeHit" onclick="return false;" href="#" coords="201,189,74" shape="circle">
                    <area alt="3" title="3" points="3" v-on:click="axeHit" onclick="return false;" href="#" coords="197,191,112" shape="circle">
                    <area alt="2" title="2" points="2" v-on:click="axeHit" onclick="return false;" href="#" coords="202,187,157" shape="circle">
                    <area alt="1" title="1" points="1" v-on:click="axeHit" onclick="return false;" href="#" coords="198,189,191" shape="circle">
                    <area alt="0" title="0" points="0" v-on:click="axeHit" onclick="return false;" href="#" coords="0,2,396,375" shape="rect">
                  </map>
                  <i v-for="(hit, hIdx) in getAllScoredHits()" :key="'hit-'+hIdx"
                    class="fas fa-xmark app-hit-marker"
                    :class="{ 'app-hit-marker-recent': hit.mostRecent }"
                    :style="getHitDotStyle(hit, hit.playerIndex, 400, 377, 200, 189)">
                  </i>
                  <div v-if="showBullseyeAnim" class="bullseye-overlay">
                    <div class="bullseye-ring bullseye-ring-1"></div>
                    <div class="bullseye-ring bullseye-ring-2"></div>
                    <div class="bullseye-ring bullseye-ring-3"></div>
                    <div class="bullseye-text">BULLSEYE!</div>
                  </div>
                  <div v-if="showScoreAnim" class="score-popup-overlay">
                    <div class="score-popup-text" :class="'score-popup-' + scoreAnimValue">{{ scoreAnimValue }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="hit-legend">
          <span v-for="(mp, pIdx) in match.matchPlayers" :key="'legend-'+pIdx" class="hit-legend-item">
            <i class="fas fa-xmark" :style="{ color: getPlayerColor(pIdx) }"></i> {{ mp.player.given_name || mp.player.name }}
          </span>
        </div>
      </div>

      <div v-if="gameType === GameType.ROUNDROBIN" class="round-robin">
        <div class="columns is-mobile" style="margin: 0px;">
          <div class="column is-1 round-robin-throws">
            <MatchPlayer v-if="matchPlayer1 != null" :matchPlayer="matchPlayer1" :gameType="gameType"/>
            <MatchPlayerEmpty v-if="matchPlayer1 != null && matchPlayer1.id === ''" :matchPlayer="matchPlayer1" :gameType="gameType"/>
          </div>
          <div class="column is-10" v-if="matchPlayer1 != null && matchPlayer2 != null">
            <div class="round-robin-target">
              <div style="text-align: center;">
                <div class="target-hit-overlay">
                  <img class="axes2-target" :src="`${publicPath}img/Target_400x377.PNG`" :usemap="'#'+mapUniqueId" width="400" height="377">
                  <map :name="mapUniqueId">
                    <area alt="5" title="5" points="5" v-on:click="axeHit" onclick="return false;" href="#" coords="200,189,29" shape="circle">
                    <area alt="4" title="4" points="4" v-on:click="axeHit" onclick="return false;" href="#" coords="201,189,74" shape="circle">
                    <area alt="3" title="3" points="3" v-on:click="axeHit" onclick="return false;" href="#" coords="197,191,112" shape="circle">
                    <area alt="2" title="2" points="2" v-on:click="axeHit" onclick="return false;" href="#" coords="202,187,157" shape="circle">
                    <area alt="1" title="1" points="1" v-on:click="axeHit" onclick="return false;" href="#" coords="198,189,191" shape="circle">
                    <area alt="0" title="0" points="0" v-on:click="axeHit" onclick="return false;" href="#" coords="0,2,396,375" shape="rect">
                  </map>
                  <i v-for="(hit, hIdx) in getAllScoredHits()" :key="'hit-'+hIdx"
                    class="fas fa-xmark app-hit-marker"
                    :class="{ 'app-hit-marker-recent': hit.mostRecent }"
                    :style="getHitDotStyle(hit, hit.playerIndex, 400, 377, 200, 189)">
                  </i>
                  <div v-if="showBullseyeAnim" class="bullseye-overlay">
                    <div class="bullseye-ring bullseye-ring-1"></div>
                    <div class="bullseye-ring bullseye-ring-2"></div>
                    <div class="bullseye-ring bullseye-ring-3"></div>
                    <div class="bullseye-text">BULLSEYE!</div>
                  </div>
                  <div v-if="showScoreAnim" class="score-popup-overlay">
                    <div class="score-popup-text" :class="'score-popup-' + scoreAnimValue">{{ scoreAnimValue }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-1 round-robin-throws">
              <MatchPlayer v-if="matchPlayer2 != null" :matchPlayer="matchPlayer2" :gameType="gameType"/>
              <MatchPlayerEmpty v-if="matchPlayer2 != null && matchPlayer2.id === ''" :matchPlayer="matchPlayer2" :gameType="gameType"/>
          </div>
        </div>
        <div class="columns is-mobile" style="margin-top: 0px; height: 60px;">
          <div class="column is-5 match-player" v-if="matchPlayer1 != null">
            <i class="fas fa-xmark" :style="{ color: getPlayerColor(0) }"></i>
            {{ playerName(matchPlayer1) }}
            <span v-if="matchPlayer1 != null && matchPlayer1.bye"><sup>(bye)</sup></span>
          </div>
          <div class="column is-2">

          </div>
          <div class="column is-5 match-player" v-if="matchPlayer2 != null" style="padding: 0px; text-align: right;">
            {{ playerName(matchPlayer2) }}
            <i class="fas fa-xmark" :style="{ color: getPlayerColor(1) }"></i>
            <span v-if="matchPlayer2 != null && matchPlayer2.bye"><sup>(bye)</sup></span>
          </div>
        </div>
      </div>

      <div v-if="gameType === GameType.ROUNDROBIN && matchPlayer1 != null && matchPlayer2 != null && !match.completed">
          <button class="button is-danger" @click="markMatchCompleted(match)" title="Done"><span class="done"><i class="fas fa-check"></i> Done</span></button>&nbsp;
          <button class="button is-info" @click="swapLanes(match)" title="Swap Lanes"><span><i class="fas fa-chevron-right"></i> Swap Lanes</span></button>
      </div>
      
      <div v-if="gameType === GameType.TOURNAMENT && !match.completed">
          <button class="button is-danger" @click="markMatchCompleted(match)" title="Done"><span class="done"><i class="fas fa-check"></i> Done</span></button>&nbsp;
          <button class="button is-info" @click="advanceLanes(match)" title="Advance Lanes"><span><i class="fas fa-chevron-right"></i> Advance Lanes</span></button>&nbsp;
      </div>

      <div v-if="gameType == GameType.SOLO || gameType == 'Practice'" class="columns">
        <div class="column">
          <div v-for="matchPlayer in match.matchPlayers" :key="matchPlayer.matchPlayer">
              <MatchPlayer :matchPlayer="matchPlayer" :gameType="gameType"/>
          </div>
        </div>
        <div class="column target-box">
          <div class="target-hit-overlay">
            <img class="axes2-target" :src="`${publicPath}img/Target.png`" :usemap="'#'+mapUniqueId" width="315" height="300">
            <map :name="mapUniqueId">
                <area target="" alt="1" title="" href="#" v-on:click="axeHit" onclick="return false;" points="5" coords="157,150,20" shape="circle">
                <area target="" alt="2" title="" href="#" v-on:click="axeHit" onclick="return false;" points="4" coords="157,150,60" shape="circle">
                <area target="" alt="3" title="" href="#" v-on:click="axeHit" onclick="return false;" points="3" coords="157,150,91" shape="circle">
                <area target="" alt="4" title="" href="#" v-on:click="axeHit" onclick="return false;" points="2" coords="157,150,123" shape="circle">
                <area target="" alt="5" title="" href="#" v-on:click="axeHit" onclick="return false;" points="1" coords="156,150,155" shape="circle">
                <area target="" alt="0" title="" href="#" v-on:click="axeHit" onclick="return false;" points="0" coords="315,1,1,300" shape="rect">
            </map>
            <i v-for="(hit, hIdx) in getAllScoredHits()" :key="'hit-'+hIdx"
              class="fas fa-xmark app-hit-marker"
              :class="{ 'app-hit-marker-recent': hit.mostRecent }"
              :style="getHitDotStyle(hit, hit.playerIndex, 315, 300, 157, 150)">
            </i>
            <div v-if="showBullseyeAnim" class="bullseye-overlay">
              <div class="bullseye-ring bullseye-ring-1"></div>
              <div class="bullseye-ring bullseye-ring-2"></div>
              <div class="bullseye-ring bullseye-ring-3"></div>
              <div class="bullseye-text">BULLSEYE!</div>
            </div>
            <div v-if="showScoreAnim" class="score-popup-overlay">
              <div class="score-popup-text" :class="'score-popup-' + scoreAnimValue">{{ scoreAnimValue }}</div>
            </div>
          </div>
          <div class="last-throw-box">
            <span class="is-size-3 is-light last-throw">{{ (this.lastThrowPoints === 0 ? '' : this.lastThrowPoints) }}</span>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import MatchPlayer from '@/components/MatchPlayer';
import MatchPlayerEmpty from '@/components/MatchPlayerEmpty';
import { GameType } from '@/enum/gameType.js';

export default {
  props: [
    'match',
    'gameType'
  ],
  data () {
    return {
      GameType,
      publicPath: process.env.BASE_URL,
      points: 0,
      lastThrowPoints: null,
      matchPlayer1: null,
      matchPlayer2: null,
      componentKey: 0,
      matchComponentKey: 0,
      showBullseyeAnim: false,
      showScoreAnim: false,
      scoreAnimValue: 0,
      animTimer: null
    }
  },
  components : {
    MatchPlayer,
    MatchPlayerEmpty
  },
  computed: {
    mapUniqueId() {
      if (this.match != null) {
        return "image-map" + this.match.id.toString();
      } else {
        return "image-map";
      }
    },
    debugStr() {
      return JSON.stringify(this.match);
    }
  },
  methods: {
    sendBroadcastControlMessage(control_type, control_value, title, source) {
      this.$parent.$parent.sendBroadcastControlMessage(control_type, control_value, title, source);
    },
    getPlayerColor(index) {
      // Golden angle spacing for visually distinct colors at any player count
      var hue = (index * 137.508 + 180) % 360;
      return 'hsl(' + hue + ', 90%, 65%)';
    },
    getAllScoredHits() {
      var hits = [];
      this.match.matchPlayers.forEach(function(mp, pIdx) {
        mp.throws.forEach(function(t) {
          if (t.scored && t.xPos > 0 && t.yPos > 0) {
            hits.push({ xPos: t.xPos, yPos: t.yPos, isBullsEye: t.isBullsEye, mostRecent: t.mostRecent, playerIndex: pIdx });
          }
        });
      });
      return hits;
    },
    computeHitOffset(imgW, imgH, bullX, bullY) {
      var bullseyes = [];
      this.match.matchPlayers.forEach(function(mp) {
        mp.throws.forEach(function(t) {
          if (t.scored && t.isBullsEye && t.xPos > 0) {
            bullseyes.push(t);
          }
        });
      });
      if (bullseyes.length > 0) {
        var avgX = bullseyes.reduce(function(s, t) { return s + t.xPos; }, 0) / bullseyes.length;
        var avgY = bullseyes.reduce(function(s, t) { return s + t.yPos; }, 0) / bullseyes.length;
        return { x: avgX - bullX, y: avgY - bullY };
      }
      var allThrows = this.getAllScoredHits();
      if (allThrows.length > 0 && allThrows.some(function(t) { return t.xPos > imgW; })) {
        var avgX = allThrows.reduce(function(s, t) { return s + t.xPos; }, 0) / allThrows.length;
        var avgY = allThrows.reduce(function(s, t) { return s + t.yPos; }, 0) / allThrows.length;
        return { x: avgX - bullX, y: avgY - bullY };
      }
      return { x: 0, y: 0 };
    },
    getHitDotStyle(hit, playerIndex, imgW, imgH, bullX, bullY) {
      var offset = this.computeHitOffset(imgW, imgH, bullX, bullY);
      var xPct = ((hit.xPos - offset.x) / imgW) * 100;
      var yPct = ((hit.yPos - offset.y) / imgH) * 100;
      xPct = Math.max(0, Math.min(100, xPct));
      yPct = Math.max(0, Math.min(100, yPct));
      return {
        left: xPct + '%',
        top: yPct + '%',
        color: this.getPlayerColor(playerIndex)
      };
    },
    playerName: function(matchPlayer) {
      return (matchPlayer.player.given_name || matchPlayer.player.name);
    },
    cloneAsObject: function(obj) {
      if (obj === null || !(obj instanceof Object)) {
          return obj;
      }
      var temp = (obj instanceof Array) ? [] : {};
      // ReSharper disable once MissingHasOwnPropertyInForeach
      for (var key in obj) {
          temp[key] = this.cloneAsObject(obj[key]);
      }
      return temp;
    },
    advanceLanes(match) {
      //counter clickwise
      //let first = match.matchPlayers.shift();
      //match.matchPlayers.push(first);

      //clockwise
      var arr = match.matchPlayers;
      
      let last = arr.pop();
      arr.splice(0, 0, last); 
      
      match.matchPlayers = arr;

      //this.$parent.$parent.forceRerender();
      this.setNextThrowTournament();
      
      this.forceMatchPlayersRerender();
    },
    forceMatchPlayersRerender() {
      this.matchComponentKey++;
    },
    swapLanes(match) {
      //console.log(match);

      var p1 = this.matchPlayer1;
      var p2 = this.matchPlayer2;

      this.matchPlayer1 = p2;
      this.matchPlayer2 = p1;

/*
      //console.log("swap lanes");
      var p1 = this.cloneAsObject(match.matchPlayers[0]);
      var p2 = this.cloneAsObject(match.matchPlayers[1]);

      match.matchPlayers[0] = p2;
      match.matchPlayers[1] = p1;
      */
    },
    getFirstAndLastUppercase: function(str) {
      if (str.length < 2) {
        return str.toUpperCase(); // If the string is too short, just return it in uppercase
      }
      const firstLetter = str.charAt(0).toUpperCase();
      const lastLetter = str.charAt(str.length - 1).toUpperCase();
      return firstLetter + lastLetter;
    },        
    markMatchCompleted(match) {
      //console.log("markMatchCompleted");
      //console.log(match);
      var winner = null;
      if (this.gameType !== GameType.SOLO) {
        winner = this.markWinner(match);
      }
      match.completed = true;

      if (this.gameType === GameType.TOURNAMENT) {
      
        this.markTournamentMatchWinner(match, winner);

        //broadcast to display
        var m = {
          uniqueItemId: match.uniqueId,
          uniqueId: this.$parent.$parent.gameData.uniqueId,
          match: match,
          title: this.$parent.$parent.gameData.title,
          league: this.$parent.$parent.gameData.league,
          lane_id: (this.$parent.$parent.gameData?.lane_id ? this.getFirstAndLastUppercase(this.$parent.$parent.gameData.lane_id) : "")
        }

        this.sendBroadcastControlMessage('match', m, 'Match Completed','markMatchCompleted');
        
        match.display = false;
        
        var ranking_data = {
          uniqueItemId: this.$parent.$parent.generateUniqueId(),
          playersSortedByAverage: this.$parent.$parent.playersSortedByAverage,
          uniqueId: this.$parent.$parent.gameData.uniqueId,
          title: this.$parent.$parent.gameData.title,
          league: this.$parent.$parent.gameData.league,
          lane_id: (this.$parent.$parent.gameData?.lane_id ? this.getFirstAndLastUppercase(this.$parent.$parent.gameData.lane_id) : "")
        };
        this.sendBroadcastControlMessage('rankings', ranking_data, 'Rankings','markMatchCompleted');

        //is the next match the first match of the next round??
        var nextMatch = null;
        var nextRound = null;
        var takeNextMatch = false;
        var takeNextRound = false;
        var gameData = this.$parent.$parent.gameData;
        for (var x = 0; x < gameData.sets.length; x++) {
            for (var y = 0; y < gameData.sets[x].rounds.length; y++) {
                var rnd = gameData.sets[x].rounds[y];
                if (takeNextRound) {
                  nextRound = rnd;
                  takeNextRound = false;
                }
                for (var z = 0; z < rnd.matches.length; z++) {
                    var m = rnd.matches[z];
                    if (takeNextMatch) {
                        nextMatch = m;
                        takeNextMatch = false;
                    }
                    if (m.uniqueId === match.uniqueId) {
                        takeNextMatch = true;
                        takeNextRound = true;
                    }
                }
            }
        }

        var isFinals = (nextMatch === null || nextMatch.type === "Finals" ? true : false);

        if (!isFinals && nextMatch != null && nextMatch.id === 1) {
          this.$parent.$parent.showPlayerManagement = true;
          this.$parent.showPlayerManagementPlayerOptions = true;
          this.$parent.$parent.nextRoundNumber = nextRound.id;

          match.display = false;
          match.completed = true;

          this.$parent.$parent.forceRerender();
        } else {
          this.openNextMatch(match);
        }
 
        this.$parent.$parent.saveGameInProgress(GameType.TOURNAMENT);

      } else if (this.gameType === GameType.ROUNDROBIN) {
        var openNextMatch = true;
        //if finals are complete, don't openNextMatch

        var winnerName = winner.player.name;
        //this.$parent.$parent.$parent.submitTickerItem(this.$parent.$parent.gameData, "Match Completed - Winner: " + winnerName, 'match_completed', match);

        var ranking_data = {
          playersSortedByAverage: this.$parent.$parent.playersSortedByAverage
        };
        //this.$parent.$parent.$parent.submitTickerItem(this.$parent.$parent.gameData, "Match Completed - Winner: " + winnerName, 'rankings', ranking_data);

        //mark finals as completed
        //console.log("Match->areFinalsCompleted?");

        //are we on finals? assume if finals players are set, then we're in the finals...
        var numFinalPlayers = this.$parent.getCountFinalPlayers();
        if (numFinalPlayers != 0) {
          var finalsCompleted = this.$parent.areFinalsCompleted();

          if (finalsCompleted) this.$parent.lockFinals();

          //console.log("finalsCompleted? " + finalsCompleted);
          if (finalsCompleted) openNextMatch = false;
        } else {
          //if there is no next match, then show final player selection
          var hasNextMatch = this.hasNextMatch(match);
          //alert("hasNextMatch", hasNextMatch);
          //console.log("hasNextMatch", hasNextMatch);
          if (hasNextMatch) {
            this.$parent.$parent.showFinalsPlayerSelection = false;
          } else {
            this.$parent.$parent.showFinalsPlayerSelection = true;
          }
        }

        //broadcast to display

//TODO Missing Ranking display??


        var m = {
          uniqueItemId: match.uniqueId,
          uniqueId: this.$parent.$parent.gameData.uniqueId,
          match: match,
          title: this.$parent.$parent.gameData.title,
          league: this.$parent.$parent.gameData.league,
          lane_id: (this.$parent.$parent.gameData?.lane_id ? this.getFirstAndLastUppercase(this.$parent.$parent.gameData.lane_id) : "")
        }

        this.sendBroadcastControlMessage('match', m, 'Match Completed','markMatchCompleted');
        
        match.display = false;
        
        var ranking_data = {
          uniqueItemId: this.$parent.$parent.generateUniqueId(),
          playersSortedByAverage: this.$parent.$parent.playersSortedByAverage,
          uniqueId: this.$parent.$parent.gameData.uniqueId,
          title: this.$parent.$parent.gameData.title,
          league: this.$parent.$parent.gameData.league,
          lane_id: (this.$parent.$parent.gameData?.lane_id ? this.getFirstAndLastUppercase(this.$parent.$parent.gameData.lane_id) : "")
        };
        this.sendBroadcastControlMessage('rankings', ranking_data, 'Rankings','markMatchCompleted');

        if (openNextMatch) this.openNextMatch(match);

        this.$parent.$parent.saveGameInProgress(GameType.ROUNDROBIN);

      } else if (this.gameType === GameType.SOLO) {
        this.openNextMatch(match);

        this.$parent.$parent.saveGameInProgress(GameType.SOLO);

      }
    },
    generateUniqueId() {
        var d = new Date().getTime();//Timestamp
        var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16;//random number between 0 and 16
            if(d > 0){//Use timestamp until depleted
                r = (d + r)%16 | 0;
                d = Math.floor(d/16);
            } else {//Use microseconds since page-load if supported
                r = (d2 + r)%16 | 0;
                d2 = Math.floor(d2/16);
            }
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    },
    openNextMatch(match) {
      //console.log("Match: openNextMatch");
      this.$parent.openNextMatch(match);
    },
    hasNextMatch(match) {
      return this.$parent.hasNextMatch(match);
    },
    markTournamentMatchWinner(match, winner) {
      for (var i = 0; i < match.matchPlayers.length; i++) {
        if (match.matchPlayers[i].id === winner.id) {
          //console.log("marked winner " + match.matchPlayers[i].id);
          match.matchPlayers[i].winner = true;
        }
      }
    },
    markWinner(match) {
      var winner = null;
      if (this.gameType === GameType.TOURNAMENT) {

        var list = [];
        
        for (var x = 0; x < match.matchPlayers.length; x++) {
          var matchPlayer = match.matchPlayers[x];
          var pts = 0;
          matchPlayer.throws.forEach(t => {
            pts += t.basicScore;
          })
          list.push({ "player" : matchPlayer, "total" : pts });
        }

        list.sort((a, b) => a.total <= b.total);
        winner = list[0].player;

        for (var x = 0; x < match.matchPlayers.length; x++) {
          var matchPlayer = match.matchPlayers[x];
          if (matchPlayer.id === winner.id) {
            match.matchPlayers[x].winner = true;
            match.winnerId = winner.id;
          }
        }

      } else {
        var isFinals = (match.id.indexOf("Finals") != -1);
        if (isFinals && match.matchPlayers[0].bye) {
            match.matchPlayers[1].winner = true;
            winner = match.matchPlayers[1];
            match.matchPlayers[0].winner = false;
            match.winnerId = match.matchPlayers[1].id;
        } else if (isFinals && match.matchPlayers[1].bye) {
            match.matchPlayers[0].winner = true;
            winner = match.matchPlayers[0];
            match.matchPlayers[1].winner = false;
            match.winnerId = match.matchPlayers[0].id;
        } else {
          var totalScorePlayer1 = this.getTotalThrowsScore(match.matchPlayers[0]);
          var totalScorePlayer2 = this.getTotalThrowsScore(match.matchPlayers[1]);

          var totalBullsPlayer1 = this.getTotalBullseyes(match.matchPlayers[0]);
          var totalBullsPlayer2 = this.getTotalBullseyes(match.matchPlayers[1]);
          
          if (totalScorePlayer1 === totalScorePlayer2) {
            if (totalBullsPlayer2 > totalBullsPlayer1) {
              match.matchPlayers[1].winner = true;
              winner = match.matchPlayers[1];
              match.matchPlayers[0].winner = false;
              match.winnerId = match.matchPlayers[1].id;
            } else {
              match.matchPlayers[0].winner = true;
              winner = match.matchPlayers[0];
              match.matchPlayers[1].winner = false;
              match.winnerId = match.matchPlayers[0].id;
            }
          } else if (totalScorePlayer1 > totalScorePlayer2) {
            match.matchPlayers[0].winner = true;
            winner = match.matchPlayers[0];
            match.matchPlayers[1].winner = false;
            match.winnerId = match.matchPlayers[0].id;
          } else {
            match.matchPlayers[1].winner = true;
            winner = match.matchPlayers[1];
            match.matchPlayers[0].winner = false;
            match.winnerId = match.matchPlayers[1].id;
          }
        }
      }
      return winner;
    },
    getTotalBullseyes(matchPlayer) {
      var total = 0;
      var ts = matchPlayer.throws;
      ts.forEach(t => {
        if (t.isBullsEye) total++;
      });
      return total;
    },
    getTotalThrowsScore(matchPlayer) {
      return this.$parent.calculateTotalThrowsMatch(matchPlayer.throws);
    },
    calculateTotalThrowsMatch(throws) {
      // Bridge method for child components (MatchPlayer)
      return this.$parent.calculateTotalThrowsMatch(throws);
    },
    unsetIsActive() {
      for (var x = 0; x < this.match.matchPlayers.length; x++) {
        var player = this.match.matchPlayers[x];
        for(var i=0; i < player.throws.length; i++) {
          var _throw = player.throws[i];
          if (_throw.isActive) {
            _throw.isActive = false;
          }
        }
      }
    },
    setNextThrowTournament: function(last) {
      this.unsetIsActive();
      
      //how many throws are there?
      var numThrows = this.match.matchPlayers[0].throws.length;

      var p = null;
      for(var i = 0; i < numThrows; i++) {
        for (var x = 0; x < this.match.matchPlayers.length; x++) {
          //console.log("looking at player " + x + " throw " + i);
          var thrw = this.match.matchPlayers[x].throws[i];
          if (thrw.scored === false) {
            thrw.isActive = true;
            p = this.match.matchPlayers[x];
          }
          if (p != null) break;
        }
        if (p != null) break;
      }
      //if (p != null) {
      //  this.$parent.$parent.$parent.submitTickerItem(this.$parent.$parent.gameData, "Now Throwing: " + p.player.name ,'now_throwing', p);
      //}
      /*
      var p = last[0]; //last player
      var t = last[1]; //last throw
      
      var nextPlayer;
      if (p === (this.match.matchPlayers.length-1)) {
        nextPlayer = this.match.matchPlayers[0];
      } else {
        nextPlayer = this.match.matchPlayers[p+1];
      }

      if (nextPlayer) {
        var throws = nextPlayer.throws.length;
        for (var x = 0; x < throws; x++) {
          if (nextPlayer.throws[x].scored === false) {
            nextPlayer.throws[x].isActive = true;
            break;
          }
        }
      }*/

      //
      //
      //this.$parent.$parent.forceRerender();
      //this.forceRerender();
    },
    forceRerender: function() {
      this.componentKey++;
    },
    setNextThrowRoundRobin: function(last) {
      //console.log("setNextThrowRoundRobin");

      //var p = last[0]; //last player
      //var t = last[1]; //last throw

      var player1 = this.match.matchPlayers[0];
      var player2 = this.match.matchPlayers[1];

      var next_throw_player = null;

      if (player1.bye && player1.id === '') {
        var throws = player2.throws.length;
        for (var x = 0; x < throws; x++) {
          if (player2.throws[x].scored === false) {
            player2.throws[x].isActive = true;
            next_throw_player = player2;
            break;
          }
        }
      } else if (player2.bye && player2.id === '') {
        var throws = player1.throws.length;
        for (var x = 0; x < throws; x++) {
          if (player1.throws[x].scored === false) {
            player1.throws[x].isActive = true;
            next_throw_player = player1;
            break;
          }
        }
      } else {
        var throws = player1.throws.length;
        for (var x = 0; x < throws; x++) {
          if (player1.throws[x].scored === false) {
            player1.throws[x].isActive = true;
            next_throw_player = player1;
            break;
          } else if (player2.throws[x].scored === false) {
            player2.throws[x].isActive = true;
            next_throw_player = player2;
            break;
          }
        }
      }
      //if (next_throw_player != null) {
      //  this.$parent.$parent.$parent.submitTickerItem(this.$parent.$parent.gameData, "Now Throwing: " + next_throw_player.player.name ,'now_throwing', next_throw_player);
      //}
    },
    setNextThrow: function() {
      //console.log("setNextThrow");
      var player = this.match.matchPlayers[0]; //solo mode
      //console.log(player)
      for(var y = 0; y < player.throws.length; y++) {
        if (player.throws[y].scored === false) {
          player.throws[y].isActive = true;
          //console.log("next throw: "  + y)
          break;
        }
      }
    },
    recordAxeHitScore: function(event, pts) {
      //console.log("recordAxeHitScore pts: " + pts);
      //record the score on the isActive throw

      for (var x = 0; x < this.match.matchPlayers.length; x++) {
        var player = this.match.matchPlayers[x];
        var numThrows = player.throws.length;
        for(var i=0; i < player.throws.length; i++) {
          var _throw = player.throws[i];
          _throw.mostRecent = false;

          //if it's the last throw on a match and it's SOLO
          if (i+1 == numThrows && this.gameType === GameType.SOLO) {
            this.$parent.$parent.saveGameInProgress(GameType.SOLO);
          }

          if (_throw.isActive) {
            //console.log("player " + x + " throw " + i + " is active, scored " + pts + " points");
           
           _throw.mostRecent = true;

            _throw.basicScore = pts;
            _throw.xPos = event.offsetX;
            _throw.yPos = event.offsetY;
            _throw.isBullsEye = (pts === 5 ? true : false);
            _throw.isVisible = true;
            _throw.scored = true;

            _throw.isActive = false;

            var m = {
              uniqueItemId: this.match.uniqueId,
              uniqueId: this.$parent.$parent.gameData.uniqueId,
              match: this.match,
              title: this.$parent.$parent.gameData.title,
              league: this.$parent.$parent.gameData.league,
              lane_id: (this.$parent.$parent.gameData?.lane_id ? this.getFirstAndLastUppercase(this.$parent.$parent.gameData.lane_id) : "")
            }
            if (this.gameType === GameType.TOURNAMENT || this.gameType === GameType.ROUNDROBIN) {
              this.sendBroadcastControlMessage('match', m, 'Match','recordAxeHitScore');
              var ranking_data = {
                uniqueItemId: this.$parent.$parent.generateUniqueId(),
                playersSortedByAverage: this.$parent.$parent.playersSortedByAverage,
                uniqueId: this.$parent.$parent.gameData.uniqueId,
                title: this.$parent.$parent.gameData.title,
                league: this.$parent.$parent.gameData.league,
                lane_id: (this.$parent.$parent.gameData?.lane_id ? this.getFirstAndLastUppercase(this.$parent.$parent.gameData.lane_id) : "")
              };
              this.sendBroadcastControlMessage('rankings', ranking_data, 'Rankings','recordAxeHitScore');
            }
            return [x,i];
            //break;
          }
        }
      }
     
      return null;
    },
    axeHit: function (event) {
      //console.log("axeHit - this.match.completed: " + this.match.completed);

      var pts = event.target.getAttribute("points");
      pts = parseInt(pts);

      //coordinates
      //console.log(event.offsetX);
      //console.log(event.offsetY);
      if (!this.match.completed) {
        if (pts != null) {
          //console.log(pts);
          this.points = pts;
          this.lastThrowPoints = ""+this.points;
          //alert("this.lastThrowPoints " + this.lastThrowPoints);   
          
          //calling recordAxehitScore does something really weird...
          //
          //
          //

          var last = this.recordAxeHitScore(event, pts);
          if (last != null) {
            if (this.gameType === GameType.ROUNDROBIN) {
              this.setNextThrowRoundRobin(last);
            } else if (this.gameType === GameType.TOURNAMENT) {
              this.setNextThrowTournament(last);
            } else {
              this.setNextThrow(last);
            }
          }
          // Clear any in-flight animation before starting a new one
          if (this.animTimer) clearTimeout(this.animTimer);
          this.showBullseyeAnim = false;
          this.showScoreAnim = false;

          var self = this;
          if (pts === 5) {
            this.showBullseyeAnim = true;
            this.animTimer = setTimeout(function() { self.showBullseyeAnim = false; self.animTimer = null; }, 1500);
          } else {
            this.scoreAnimValue = pts;
            this.showScoreAnim = true;
            this.animTimer = setTimeout(function() { self.showScoreAnim = false; self.animTimer = null; }, 900);
          }
          this.forceRerender();
          this.$parent.$parent.rankingsRefeshKey += 1;
        }
      }
    },
    setNextActive: function(throws, lastThrowindex) {
      var found = false;
      for(var i = lastThrowindex+1; i < throws.length; i++) {
        if (throws[i].basicScore === 0) {
          throws[i].isActive = true;
          found = true;
          break;
        }
      }
      return found;
    }
  },
  mounted() {
    setTimeout(() => {
      //console.log("mounted")
      this.matchPlayer1 = this.match.matchPlayers[0];
      this.matchPlayer2 = this.match.matchPlayers[1];
      //console.log(this.matchPlayer1);
      //console.log(this.matchPlayer2);
    }, 500);
  }
}
</script>

<style lang="scss" scoped>
.match-player {
  padding: 0px; 
  padding-left: 10px; 
  padding-right: 10px; 
  color: green; 
  font-weight: bold; 
  font-size: 20pt;
}
.done {
  font-family: Verdana !important;
  font-weight: bold;
  color: gold;
}
.locked {
  color: yellow;
  font-size: 2.0em;
}
.round-robin {
  width: 100%;
}
.round-robin-throws {
  text-align: center;
}
.round-robin-target {
  padding-top: 25px; 
  padding-left: 0px;
  padding-right: 0px;
}


.target-box {
  padding-top: 25px; 
  padding-left: 0px;
  padding-right: 0px;
}
.axes2-target {

}
.target-hit-overlay {
  position: relative;
  display: inline-block;
  overflow: hidden;
}
.app-hit-marker {
  position: absolute;
  transform: translate(-50%, -50%);
  pointer-events: none;
  z-index: 1;
  font-size: 14px;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.8);
  opacity: 0.85;
}
.app-hit-marker-recent {
  font-size: 20px;
  opacity: 1;
  filter: drop-shadow(0 0 4px currentColor);
}
.hit-legend {
  display: flex;
  justify-content: center;
  gap: 14px;
  padding: 4px 0;
  font-size: 0.75em;
  color: #ccc;
}
.hit-legend-item {
  white-space: nowrap;
}
.hit-legend-item .fa-xmark {
  margin-right: 3px;
}

/* Bullseye celebration */
.bullseye-overlay {
  position: absolute;
  inset: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  animation: bullseye-fade 1.5s ease-out forwards;
}
.bullseye-text {
  position: absolute;
  font-family: 'Orbitron', sans-serif;
  font-size: 2.2em;
  font-weight: 900;
  letter-spacing: 0.12em;
  color: gold;
  text-shadow:
    0 0 10px rgba(255, 215, 0, 0.9),
    0 0 30px rgba(255, 100, 0, 0.6),
    2px 2px 4px rgba(0,0,0,0.8);
  animation: bullseye-text-pop 0.6s cubic-bezier(0.18, 1.2, 0.4, 1) forwards;
  z-index: 2;
}
.bullseye-ring {
  position: absolute;
  border-radius: 50%;
  border: 3px solid gold;
  opacity: 0;
}
.bullseye-ring-1 {
  width: 60px;
  height: 60px;
  animation: bullseye-ring-expand 1s ease-out 0s forwards;
}
.bullseye-ring-2 {
  width: 60px;
  height: 60px;
  animation: bullseye-ring-expand 1s ease-out 0.15s forwards;
  border-color: #ff8c00;
}
.bullseye-ring-3 {
  width: 60px;
  height: 60px;
  animation: bullseye-ring-expand 1s ease-out 0.3s forwards;
  border-color: #ff4500;
}
@keyframes bullseye-ring-expand {
  0% {
    transform: scale(0.3);
    opacity: 0.9;
    border-width: 4px;
  }
  100% {
    transform: scale(4);
    opacity: 0;
    border-width: 1px;
  }
}
@keyframes bullseye-text-pop {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes bullseye-fade {
  0%, 70% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

/* Score popup (0-4) */
.score-popup-overlay {
  position: absolute;
  inset: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  animation: score-popup-fade 0.9s ease-out forwards;
}
.score-popup-text {
  font-family: 'Orbitron', sans-serif;
  font-size: 3em;
  font-weight: 900;
  letter-spacing: 0.05em;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.8);
  animation: score-popup-rise 0.9s ease-out forwards;
}
.score-popup-0 { color: #888; }
.score-popup-1 { color: #b0b0b0; }
.score-popup-2 { color: #6dcf6d; }
.score-popup-3 { color: #4db8ff; }
.score-popup-4 { color: #d4a0ff; }
@keyframes score-popup-rise {
  0% {
    transform: scale(0.4) translateY(20px);
    opacity: 0;
  }
  25% {
    transform: scale(1.1) translateY(0);
    opacity: 1;
  }
  50% {
    transform: scale(1) translateY(0);
    opacity: 1;
  }
  100% {
    transform: scale(0.8) translateY(-30px);
    opacity: 0;
  }
}
@keyframes score-popup-fade {
  0%, 50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.box {
    background-color: #000000;
    /*min-height: 540px;*/
    /*margin-bottom: 5px;*/
}
.last-throw-box {
    position: relative;
    top: -330px;
    width: 40px;
}
.last-throw {
  font-family: '28 Days Later';
  height: 20px;
  width: 20px;
}
.hit-marker {
 height: 20px;
 width: 20px;
 font-size: 2em;
 color:#97312d;
}
@media print {
  .axes2target { 
    display: none; 
  }
}
/*
@media screen and (max-width: 500px) {
  .round-robin {
    width: 500px;
  }
}*/
</style>